import { toNumber } from 'commons/utils/amountHelpers'

export type QrCodeAppProvider = 'lydia' | 'sumeria'
export type QrCodeContext = 'payment' | 'money_pot'

type BuildQrDeeplinkParams = {
	context: QrCodeContext
	provider: QrCodeAppProvider
	identifier: string
	amount?: string
	description?: string
}

const trimTrailingSlash = (url: string): string => url.replace(/\/$/, '')

const toAmountInCents = (amount?: string): number | null => {
	const value = toNumber(amount ?? '')
	if (value === null || value <= 0) {
		return null
	}
	return Math.round(value * 100)
}

const appendAmountParam = (params: URLSearchParams, amount?: string): void => {
	const amountInCents = toAmountInCents(amount)
	if (amountInCents !== null) {
		params.set('a', amountInCents.toString())
	}
}

const buildPaymentQuery = (identifier: string, amount?: string, description?: string): string => {
	const params = new URLSearchParams()
	params.set('t', identifier)
	appendAmountParam(params, amount)

	const trimmedDescription = description?.trim()
	if (trimmedDescription) {
		params.set('d', trimmedDescription)
	}

	return params.toString()
}

const buildMoneyPotQuery = (identifier: string, amount?: string): string => {
	const params = new URLSearchParams()
	params.set('id', identifier)
	appendAmountParam(params, amount)
	return params.toString()
}

export const buildQrDeeplink = ({
	context,
	provider,
	identifier,
	amount,
	description
}: BuildQrDeeplinkParams): string => {
	if (context === 'payment') {
		const query = buildPaymentQuery(identifier, amount, description)

		if (provider === 'lydia') {
			// go.lydia.me/l?t=<tag>&a=<cents>&d=<description>
			const base = trimTrailingSlash(process.env.REACT_APP_LYDIA_DEEPLINK_URL)
			return `${base}/l?${query}`
		}

		// go.sumeria.eu/l?t=<tag>&a=<cents>&d=<description>
		const base = trimTrailingSlash(process.env.REACT_APP_SUMERIA_DEEPLINK_URL)
		return `${base}/l?${query}`
	}

	const query = buildMoneyPotQuery(identifier, amount)

	if (provider === 'lydia') {
		// pots.lydia.me/collect/pots?id=<slug>&a=<cents>
		const base = trimTrailingSlash(process.env.REACT_APP_POTS_URL)
		return `${base}/collect/pots?${query}`
	}

	// go.sumeria.eu/pots?id=<slug>&a=<cents>
	const base = trimTrailingSlash(process.env.REACT_APP_SUMERIA_DEEPLINK_URL)
	return `${base}/pots?${query}`
}
